import project1 from "../images/project1.jpg";
import project2 from "../images/project2.jpg";
import project3 from "../images/project3.jpg";
import project4 from "../images/project4.jpg";
import project5 from "../images/project5.jpg";
import project6 from "../images/project6.jpg";
import project7 from "../images/project7.jpg";
import project8 from "../images/project8.png";
import project9 from "../images/project9.PNG";

const dataProjects = [
  {
    id: 1,
    url: "https://eltiempo-web.herokuapp.com/",
    img: project9,
    name: "Node.js | Express.js ",
    github: "https://github.com/Anafruiz/weather-app",
  },
  {
    id: 2,
    url: "https://anafruiz.github.io/quick-quiz/",
    img: project7,
    name: "JavaScript",
    github: "https://github.com/Anafruiz/quick-quiz",
  },
  {
    id: 3,
    url: "https://anafruiz.github.io/Rick-Morty-character-finder/#/",
    img: project1,
    name: "React",
    github: "https://github.com/Anafruiz/Rick-Morty-character-finder",
  },
  {
    id: 4,
    url: "https://anafruiz.github.io/tv-series-searcher/",
    img: project2,
    name: "JavaScript",
    github: "https://github.com/Anafruiz/tv-series-searcher",
  },
  {
    id: 5,
    url: "https://anafruiz-react-magicians.herokuapp.com/#/",
    img: project3,
    name: "React & Node.js",
    github: "https://github.com/Anafruiz/project-promo-l-module-3-team-1",
  },
  {
    id: 6,
    url: "https://anafruiz.github.io/Local-Storage-Tapas/",
    img: project6,
    name: "JavaScript",
    github: "https://github.com/Anafruiz/Local-Storage-Tapas",
  },
  {
    id: 7,
    url: "https://anafruiz.github.io/Guess-a-number/",
    img: project4,
    name: "JavaScript",
    github: "https://github.com/Anafruiz/Guess-a-number",
  },
  {
    id: 8,
    url: "https://anafruiz.github.io/Pokemon-React/",
    img: project5,
    name: "React",
    github: "https://github.com/Anafruiz/Pokemon-React",
  },
  {
    id: 9,
    url: "https://anafruiz.github.io/gmail-react/#/",
    img: project8,
    name: "React",
    github: "https://github.com/Anafruiz/gmail-react",
  },
];
export default dataProjects;
